module.exports = __webpack_public_path__ + "static/media/pandas.3e24eae8.png";